import React, {Component} from 'react';
import './NavCopy.css';
import './NavButton.css';
// import jQuery from 'jquery';

export default class Nav extends Component {

    constructor() {
        super();
        this.state = {
            showFaq: false,
            showShare: false,
            showNavRightMenu: false,
            showFAQ1: false
        }
    }

    toggleNav = () => {
        this.setState({
            showNavRightMenu: !this.state.showNavRightMenu
        });
    }

    handleFaq = () => {
        this.setState({
            showFaq: !this.state.showFaq
        })
    }

    handleShare = () => {
        this.setState({
            showShare: !this.state.showShare
        })
    }

    handleFAQtoggle = (id) => {
        // var stateObj = {};
        var key = 'showFAQ'+id;
        // stateObj[key] = this.state[key]
    //     inputChangeHandler : function (event) {
    // this.setState({ [event.target.id]: event.target.value });
        this.setState({
            [key]: !this.state[key]
        })
    }

    render() {
        return (
            <nav id='topnav' className='nav has-shadow'>

                { /* Top left navigation title */ }
                <div className='nav-left'>
                    <span className='logo-icon'>
                        <a href='/'>
                            <img src='/images/icon.png' style={{'maxWidth': '3.0rem'}} alt='logo'/>
                        </a>
                    </span>
                    <a className='nav-item' href='/' style={{'flexDirection': 'column', 'alignItems': 'flex-start'}}>
                        <p style={{}}>
                            <strong className='is-source-pro'>Startup Financial Health Checklist</strong>
                            {/* <img src='/images/beta.png' style={{'position': 'absolute', 'maxHeight': '2.25rem', 'marginLeft': '0.3rem', 'marginTop': '-0.25rem'}} alt='beta icon'/> */}
                        </p>
                        <p style={{verticalAlign: 'top', marginTop: '-5px'}}>
                            <small className='grey-text'>powered by NorthOne</small>
                        </p>
                    </a>
                </div>

                <span className={this.state.showNavRightMenu ? 'nav-toggle is-active' : 'nav-toggle'} onClick={this.toggleNav} style={{height: "4.15rem"}}>
                    <span></span>
                    <span></span>
                    <span></span>
                </span>

                { /* Top right navigation menu */ }
                <div className={this.state.showNavRightMenu ? 'nav-right nav-menu is-active' : 'nav-right nav-menu'}>
                    <a className='nav-item is-hidden-tablet' href='https://www.northone.io/?utm_source=checklist' target='_blank'>Who Made This?</a>
                    <p className='nav-item is-hidden-tablet' onClick={this.handleFaq} target='_blank'>FAQ</p>
                    <p className='nav-item is-hidden-tablet' onClick={this.handleShare} target='_blank'>Share</p>
                    <div className='nav-item is-hidden-mobile'>
                        <div className='field is-grouped'>
                            <p className='control'>
                                <a className='button is-primary is-outlined' href='https://www.northone.io/?utm_source=checklist' target='_blank'>Who Made This?</a>
                            </p>
                            <div className='control'>
                                <p className='button is-outlined' onClick={this.handleFaq} target='_blank'>FAQ</p>
                            </div>
                            <div className='control'>
                                <p className='button is-outlined' onClick={this.handleShare} target='_blank'>Share</p>
                            </div>
                        </div>
                    </div>
                </div>

                { /* FAQ pop-up modal */}
                <div id="faqModal" className={this.state.showFaq ? 'modal is-active' : 'modal'}>
                    <div className="modal-background">
                        <div className="modal-content">
                            <h2 style={{color: "#fff"}}>Frequently Asked Questions</h2>
                            <br/>
                            <div style={{color: "#fff"}}>
                                <div className="collapsible">
                                    <div onClick={()=>this.handleFAQtoggle(1)} className={this.state['showFAQ1'] ?
                                        "collapse-title is-active"
                                        :"collapse-title"}>
                                        <span className="icon">
                                            <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                        </span>
                                        Why did you build this?
                                    </div>
                                    <p className={this.state['showFAQ1'] ?
                                        "collapse-content is-active"
                                        :"collapse-content"}>
                                        The team at <a href="https://northone.io/" target="_blank">NorthOne</a> built this tool because we believe that starting a business should be simple and accessible to everyone 💪. We’re building these tools as well as our API-enabled business banking platform (request an invite <a href="http://northone.io/api" target="_blank">here</a>!) to empower you as you build your company.
                                    </p>
                                </div>
                                <div className="collapsible">
                                    <div onClick={()=>this.handleFAQtoggle(2)} className={this.state['showFAQ2'] ?
                                        "collapse-title is-active"
                                        :"collapse-title"}>
                                        <span className="icon">
                                            <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                        </span>
                                        Who is this for?
                                    </div>
                                    <p className={this.state['showFAQ2'] ?
                                        "collapse-content is-active"
                                        :"collapse-content"}>
                                       We built this checklist for startups, small businesses, and freelancers with all levels of financial knowledge 🤓. You <b>don't</b> need to be an financial expert to use this tool.
                                    </p>
                                </div>
                                <div className="collapsible">
                                    <div onClick={()=>this.handleFAQtoggle(3)} className={this.state['showFAQ3'] ?
                                        "collapse-title is-active"
                                        :"collapse-title"}>
                                        <span className="icon">
                                            <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                        </span>
                                        How did you decide what information should be included?
                                    </div>
                                    <p className={this.state['showFAQ3'] ?
                                        "collapse-content is-active"
                                        :"collapse-content"}>
                                        As part of our mission to build <a href="http://northone.io/api" target="_blank">Canada’s first API-enabled banking platform for businesses</a> we talked to over 150 business builders and dozens of financial experts to learn what financial health metrics a business like yours needs to know.
                                    </p>
                                </div>
                                <div className="collapsible">
                                    <div onClick={()=>this.handleFAQtoggle(4)} className={this.state['showFAQ4'] ?
                                        "collapse-title is-active"
                                        :"collapse-title"}>
                                        <span className="icon">
                                            <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                        </span>
                                    How much does using this tool cost?
                                    </div>
                                    <p className={this.state['showFAQ4'] ?
                                        "collapse-content is-active"
                                        :"collapse-content"}>
                                        This checklist is free to use 🙏.
                                    </p>
                                </div>
                                <div className="collapsible">
                                    <div onClick={()=>this.handleFAQtoggle(5)} className={this.state['showFAQ5'] ?
                                        "collapse-title is-active"
                                        :"collapse-title"}>
                                        <span className="icon">
                                            <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                        </span>
                                    Shouldn’t I go to an accountant for this type of advice?
                                    </div>
                                    <p className={this.state['showFAQ5'] ?
                                        "collapse-content is-active"
                                        :"collapse-content"}>
                                        In many cases you it can be helpful to talk to an accountant or financial expert, but as a business builder it’s also good idea to level up your own knowledge.
                                    </p>
                                </div>
                                <div className="collapsible">
                                    <div onClick={()=>this.handleFAQtoggle(6)} className={this.state['showFAQ6'] ?
                                        "collapse-title is-active"
                                        :"collapse-title"}>
                                        <span className="icon">
                                            <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                        </span>
                                    What if I have other questions?
                                    </div>
                                    <p className={this.state['showFAQ6'] ?
                                        "collapse-content is-active"
                                        :"collapse-content"}>
                                        You can contact our team at  <a href="mailto:social@northone.io">social@northone.io</a> and we'll answer any other questions you have.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button className="modal-close" onClick={this.handleFaq}></button>
                </div>

                { /* Share pop-up modal */ }
                <div id="shareModal" className={this.state.showShare ? 'modal is-active' : 'modal'}>
                    <div className="modal-background"></div>
                    <div className="modal-content">
                        <div className="has-text-centered content">
                            <h2 style={{"color": "#fff"}}> Starting your business should be easy. <br />Feeling it? </h2>
                            <br/>
                            <div className="">
                                <a target="_blank" className="share-button" href="https://twitter.com/intent/tweet?text=Building+a+startup+is+hard+work%3F+https%3A%2F%startupfinancialhealthchecklist.com+makes+tracking+your+finances+simple+%28via+%40northoneapp%29">
                                    {/*<span className="icon">
                                        <i className="fa fa-twitter" aria-hidden="true"></i>
                                    </span>
                                    <span> Tweet </span>*/}
                                    <img src='images/tweet.png' alt='tweet' />
                                </a>
                            </div>
                            <div className="">
                                <a target="_blank" className="share-button" href="https://www.facebook.com/sharer/sharer.php?u=https://startupfinancialhealthchecklist.com">
                                    {/*<span className="icon">
                                        <i className="fa fa-facebook" aria-hidden="true"></i>
                                    </span>
                                    <span> Share on Facebook </span>*/}
                                    <img src='images/facebook.png' alt='facebook' />
                                </a>
                            </div>
                            <div className="">
                                <a target="_blank" className="share-button" href="https://www.linkedin.com/shareArticle?mini=true&url=https://startupfinancialhealthchecklist.com&title=Startup Financial Health Checklist&summary=Make sure your business is financially healthy&source=https://www.startupfinancialhealthchecklist.com">
                                    {/*<span className="icon">
                                        <i className="fa fa-facebook" aria-hidden="true"></i>
                                    </span>
                                    <span> Share on LinkedIn </span>*/}
                                    <img src='images/linkedin.png' alt='linkedin' />
                                </a>
                            </div>
                            <div className="">
                                <a target="_blank" className="share-button" href="http://www.reddit.com/submit?url=https://startupfinancialhealthchecklist.com&title=Startup Financial Health Checklist">
                                    {/*<span className="icon">
                                        <i className="fa fa-reddit-alien" aria-hidden="true"></i>
                                    </span>
                                    <span> Share on Reddit </span>*/}
                                    <img src='images/reddit.png' alt='reddit' />
                                </a>
                            </div>
                            <div className="">
                                <a  className="share-button" href="mailto:?subject=Startup Financial Health Checklist&body=Building a startup is hard work? https://startupfinancialhealthchecklist.com makes tracking your finances simple">
                                    {/*<span className="icon">
                                        <i className="fa fa-envelope" aria-hidden="true"></i>
                                    </span>
                                    <span> Share by Email </span>*/}
                                    <img src='images/email.png' alt='email' />
                                </a>
                            </div>
                        </div>
                    </div>
                    <button className="modal-close"  onClick={this.handleShare}></button>
                </div>
            </nav>
        )
    }

}



// WEBPACK FOOTER //
// src/components/modals/Nav.js